import { gql } from "graphql-request";
import { useFilminfo } from "src/lib/client/useFilminfo";
import { useReducer } from "react";



export default function useFilmQuiz() {
	const [quizState, quizDispatcher] = useReducer(reducer, EMPTY_STATE);
	//const [quizState, setQuizState] = useState({ num: 0, ts: (new Date()).getTime() });
	const { fiLoading, fiData } = useFilminfo(QUERY_MOVIEQUESTION,
		{ questionNumber: quizState.qNum, ts: quizState.ts },
		{ active: quizState.qNum > 0 });

	return {
		isLoading: fiLoading,
		questionNumber: quizState.qNum,
		question: fiData?.movieQuery?.getMovieQuestion,
		nextQuestion: () => quizDispatcher({ type: "nextquestion" }),
		doCorrectAnswer: () => quizDispatcher({ type: "rightanswer" }),
		doWrongAnswer: () => quizDispatcher({ type: "wronganswer" }),
		newQuiz: () => quizDispatcher({ type: "reset" }),
		livesLeft: quizState.livesLeft,
		numCorrect: quizState.numCorrect,
		isCurrentQuestionAnswered: quizState.isCurrentQuestionAnswered,
		isCurrentQuestionCorrect: quizState.isCurrentQuestionCorrect
	};
}

type QuizState = {
	qNum: number;
	ts: number;
	livesLeft: number;
	numCorrect: number;
	isCurrentQuestionAnswered: boolean;
	isCurrentQuestionCorrect?: boolean;
}

type QuizAction = {
	type: "nextquestion" | "reset" | "wronganswer" | "rightanswer";
}

const EMPTY_STATE: QuizState = {
	qNum: 0,
	ts: 0,
	livesLeft: 3,
	numCorrect: 0,
	isCurrentQuestionAnswered: false,
	isCurrentQuestionCorrect: undefined
};

function reducer(state: QuizState, action: QuizAction): QuizState {
	switch (action.type) {
		case "nextquestion":
			return { ...state, qNum: state.qNum + 1, isCurrentQuestionAnswered: false, isCurrentQuestionCorrect: undefined, ts: new Date().getTime() };
		case "reset":
			return EMPTY_STATE;
		case "wronganswer":
			const livesLeft = state.livesLeft - 1;
			return { ...state, livesLeft: livesLeft, isCurrentQuestionAnswered: true, isCurrentQuestionCorrect: false };
		case "rightanswer":
			return { ...state, numCorrect: state.numCorrect + 1, isCurrentQuestionAnswered: true, isCurrentQuestionCorrect: true };

	}
}

//#region [Other] Query
const QUERY_MOVIEQUESTION = gql`
{
    movieQuery {
        getMovieQuestion {
            question
            answerAlternatives {
                answerAlternative
                isCorrect
            }
			sanityImagePosterUrl
            sanityImageWideUrl
        }
    }
}
`;
//#endregion